var _path, _path2, _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2623.04,
    height: 1630.06,
    viewBox: "0 0 2623.04 1630.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_portocalie_mare",
    "data-name": "Forma portocalie mare",
    d: "M195.273,888.345c270.764,142.593,673.51,19.592,836.675-113.453,212.025-172.9,296.673-555.455,69.528-703.137C972.133-12.314,766.4.938,606.119,230.829c-148.8,213.429-262.844,105.012-434.8,164.131C-46.249,469.76-36.141,766.488,195.273,888.345Z",
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 790.435, 74.654)",
    fill: "#ffdc9c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_albastra_mare",
    "data-name": "Forma albastra mare",
    d: "M1665.826,24.249c260.273,3.445,138.495,199,161.887,307.287,33.794,156.443,131.837,257.6,133.974,393.409,2.144,136.272,35.052,112.989-178.735,181.114-145.225,46.277-618.531,149.593-877.53,146.165C267.5,1043.781-53.439,850.965,9.477,611.892S1027.9,15.806,1665.826,24.249Z",
    transform: "translate(751.208 -23.548) rotate(17)",
    fill: "#78cfc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(369.009 523.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M255.864,588.01l4.143,28.743V631L251.1,641.759l-10.6-2.112-9.748-14.189V596.8Z",
    transform: "translate(1338.371 -69.868)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(1560.491 506.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M247.281,652.32a25.687,25.687,0,0,0,14.405-4.928c6.133-4.725,9.4-12.334,9.206-21.459a47.523,47.523,0,0,0-1.435-10.953c-.42-1.868-.894-4.021-1.367-7.081a33.533,33.533,0,0,1,.176-12.686,5.658,5.658,0,0,0-10.993-2.681,45.651,45.651,0,0,0-.366,17.113c.528,3.371,1.056,5.741,1.516,7.812a36.653,36.653,0,0,1,1.164,8.584c.068,3.3-.46,9.071-4.766,12.388-.041.027-5.361,3.981-10.465,2.072-3.656-1.367-5.429-5.1-6.607-7.582-2.193-4.657-2.193-9.071-1.99-13.2a201.981,201.981,0,0,1,4.576-33.373,5.662,5.662,0,1,0-11.061-2.423,212.607,212.607,0,0,0-4.82,35.241c-.176,3.845-.528,10.993,3.073,18.588,1.6,3.385,4.928,10.384,12.889,13.349A19.833,19.833,0,0,0,247.281,652.32Z",
    transform: "translate(-224.354 -579.474)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M158.2,618.387c11.508,5.7,33.183-14.5,42.985-28.174,9.1-12.7,10.763-25.439,14.08-50.919.555-4.292,1.273-11.1-2.166-13.363-3.141-2.071-7.866.894-14.446,3.615-14.31,5.916-21.229,4.048-27.443,6.5C148.437,545.048,141.072,609.912,158.2,618.387Z",
    transform: "translate(1493.616 -92.081)",
    fill: "#f6cf85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M237.862,536.479c8.259,5.185,30.34-13.173,24.925,33.292-2.857,24.505-32.452,48.55-34.673,50.472-9.369,8.082-10.3-.135-26.36-3.155-14.08-2.654-17.668-3.574-23.6-13.85-3.534-6.106-1.909-10.547-.961-25.047,2.315-35.323-4.495-51.014,2.884-54.9,3.344-1.76,5.063,1.273,18.3,5.781,7.514,2.559,24.965,8.5,45.26,7.23C253.77,535.667,234.667,534.462,237.862,536.479Z",
    transform: "translate(1408.89 -92.949)",
    fill: "#ffdc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M154.421,399.884c4.671-3.9,25.48,14.094,30.34,18.3,12.984,11.224,23.259,20.1,31.3,36.121,8.2,16.327,9.4,30.733,10.113,40.453,1.07,14.7,2.329,31.775-7.7,47.67-1.963,3.114-6.688,9.87-18.3,17.817-37.015,25.331-85.321,22.6-86.2,17.817-.542-2.992,18.318-2.559,34.672-18.778,14.96-14.839,18.426-34.321,21.675-52.49,2.532-14.189,5.375-30.137.487-49.118-1.273-4.955-5.835-20.809-12.523-39.966C154.475,406.815,152.35,401.617,154.421,399.884Z",
    transform: "translate(1529.616 -136.634)",
    fill: "#f6cf85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M137.581,490.847c4.332,52.246-26.008,87.541,60.22,88.556,45.625.541,82.613-41.456,82.613-92.591s-37.042-90.465-82.613-92.591C126.858,390.918,133.343,439.887,137.581,490.847Z",
    transform: "translate(1447.299 -138.5)",
    fill: "#ffdc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M445.573,421.44l-206.8,23.111,62.346,227.26,144.458-18.859Z",
    transform: "translate(1141.947 -128.812)",
    fill: "#72beb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M167.164,395.751c-3.439-2.911-6.661-1.34-22.637-.961-10.357.244-10.926-.365-16.138.488a51.472,51.472,0,0,0-16.368,5.537,41.139,41.139,0,0,0-7.46,5.537c-1.462,1.367-2.207,2.044-2.41,2.653-1.625,4.779,9.1,16.612,20.47,16.856,6.092.122,5.239-3.236,18.534-7.46,14.635-4.657,20.7-5.781,20.7-5.781,4.156-.772,6.674-1,8.191-3.128C172.512,406,171.158,399.122,167.164,395.751Z",
    transform: "translate(1601.422 -138.513)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M148.332,407.03l-5.659,41.9-12.28,17.9L101.38,423.886l28.052-14.92Z",
    transform: "translate(1625.195 -133.911)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(1603.549 247.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M239.6,568.3a5.646,5.646,0,0,0,3.412-1.137,58.861,58.861,0,0,0,6.39-5.591c22.055-22.312,22.677-58.69,15.908-85.307-8.922-35.025-34.537-53.87-45.476-61.913-41.225-30.327-88.692-27.673-107.172-25.128a5.65,5.65,0,0,0-4.833,6.377,5.726,5.726,0,0,0,6.377,4.833c17.126-2.356,61.046-4.847,98.927,23.029,10.8,7.947,33.292,24.492,41.212,55.59,5.74,22.542,5.781,55.576-12.984,74.557a48.688,48.688,0,0,1-5.172,4.522A5.658,5.658,0,0,0,239.6,568.3Z",
    transform: "translate(-107.771 -387.788)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(1582.508 424.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M205.707,543.484c23.138,0,47.047-4.536,70.78-13.539a5.665,5.665,0,0,0,3.276-7.284,5.6,5.6,0,0,0-7.23-3.3c-36.812,13.958-73.948,16.572-107.416,7.527a154.013,154.013,0,0,1-21.215-7.432,5.591,5.591,0,0,0-7.379,2.951,5.66,5.66,0,0,0,2.938,7.433,164.136,164.136,0,0,0,66.245,13.647Z",
    transform: "translate(-136.062 -518.984)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M206.374,592.44l3.493,28.418v16.72l-8.908,12.645-10.6-2.491-9.748-16.653V597.422Z",
    transform: "translate(1456.394 -68.3)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(1693.477 249.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M158.669,482.593a5.647,5.647,0,0,0,4.522-2.261c19.428-25.778,21.256-50.594,19.36-66.854a68.476,68.476,0,0,0-4.238-17.749,5.665,5.665,0,0,0-4.048-3.3c-48.441-10.086-74.652,12.131-75.749,13.078a5.658,5.658,0,0,0,7.406,8.556c.921-.785,22.3-18.521,62.928-11.17a66.3,66.3,0,0,1,2.451,11.873c1.652,14.216.014,35.959-17.153,58.758a5.669,5.669,0,0,0,4.522,9.071Z",
    transform: "translate(-96.57 -389.805)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(1719.994 264.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M104.2,430.332a5.679,5.679,0,0,0,3.439-1.462c.19-.176,19.184-17.262,42.674-16.883a5.653,5.653,0,1,0,.176-11.3c-28.066-.433-49.592,19.035-50.486,19.861a5.651,5.651,0,0,0-.339,7.988A5.569,5.569,0,0,0,104.2,430.332Z",
    transform: "translate(-98.169 -400.675)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M102.545,537.78c2.491-2.789,7.189-2.288,13.539-1.625,4.752.5,8.963.948,12.28,4.332.636.65,4.183,4.265,3.615,9.206a11.264,11.264,0,0,1-3.615,6.688c-4.522,4.576-10.628,4.386-11.738,4.332a15.567,15.567,0,0,1-7.582-2.342C101.922,553.783,98.47,542.329,102.545,537.78Z",
    transform: "translate(1642.267 -88.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M265.86,451.966,420.445,435.6s6.742-.488,7.7,2.41.839,8.651.961,11.481c.095,2.153.122,69.765-3.249,89.03s-12.632,45.4-24.194,64.661a250.4,250.4,0,0,1-16,22.826l-74.557,8.638,8.543,26.793c-1.381.013-2.247.013-2.247.013Z",
    transform: "translate(1121.707 -123.812)",
    fill: "#78cfc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M303.408,578.7l82.031-9.491-1.868,31.45L239.1,619.52l-1.719-5.389c7.771-.095,33.847-.7,39.167-4.793C280.582,606.239,292.4,592.93,303.408,578.7Z",
    transform: "translate(1203.963 -76.521)",
    fill: "#6aa5ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M372.541,576.22c-10.993,14.216-22.826,27.524-26.861,30.638-5.321,4.089-31.4,4.7-39.167,4.793l-8.543-26.793Z",
    transform: "translate(1134.83 -74.04)",
    fill: "#72beb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M170.753,542.94c3.8-3.385,6.7-5.971,9.87-5.537,5.822.785,10.79,11.413,8.191,18.061-1.543,3.94-4.711,3.818-6.742,8.908-1.015,2.545-.7,3.764-.961,10.357-.271,6.945-.42,10.411-1.2,14.2a44.076,44.076,0,0,1-5.537,13.972,32.331,32.331,0,0,1-7.947,9.4c-5.646,4.373-11.44,5.321-15.651,6.025a47.035,47.035,0,0,1-21.432-1.679c-6.756-2.139-10.831-2.6-12.036-5.781-1.354-3.561,1.5-7.812,2.884-9.87,1.435-2.125,3.682-5.483,7.23-6.025,3.574-.542,4.671,2.356,9.626,3.859,8.042,2.423,15.583-2.072,16.138-2.41A21.555,21.555,0,0,0,161.6,586.06c1.99-4.739,1.923-10.127,1.679-20.7-.176-7.934-.758-10.344.961-14.2A23.7,23.7,0,0,1,170.753,542.94Z",
    transform: "translate(1562.931 -87.793)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 50.594,
    cy: 50.594,
    rx: 50.594,
    ry: 50.594,
    transform: "translate(1443.063 350.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(1628.811 518.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M200.475,656.843a17.569,17.569,0,0,0,3.534-.352,20.469,20.469,0,0,0,12.753-8.678c4.251-6.377,3.466-13.2,2.843-18.7a57.4,57.4,0,0,0-1.8-8.976c-.284-1.056-.555-2.1-.785-3.209-.921-4.332-2.843-13.363-2.315-22.948a5.643,5.643,0,0,0-5.334-5.957,5.564,5.564,0,0,0-5.957,5.334c-.542,9.775.975,18.589,2.545,25.926.271,1.3.6,2.5.921,3.737a47.412,47.412,0,0,1,1.489,7.378c.582,5.091.839,8.367-1.015,11.142a9.169,9.169,0,0,1-5.551,3.845c-4.657.934-8.814-3.222-8.854-3.263-9-9.071-6.878-36-5.47-42.8a5.7,5.7,0,0,0-4.292-6.715,5.578,5.578,0,0,0-6.729,4.116c-.095.366-6.986,37.827,8.462,53.383A22.957,22.957,0,0,0,200.475,656.843Z",
    transform: "translate(-174.844 -588.004)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 21.716,
    cy: 15.299,
    rx: 21.716,
    ry: 15.299,
    transform: "translate(1689.466 351.765)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M223.06,472.419c0,8.448.162,15.3,8.611,15.3a15.3,15.3,0,1,0,0-30.6C223.223,457.12,223.06,463.971,223.06,472.419Z",
    transform: "translate(1361.82 -116.186)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(1668.998 439.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M134.072,625.656a41.38,41.38,0,0,0,16.49-3.236c3.588-1.544,11.941-5.158,17.478-13.986,3.263-5.2,6.038-9.639,6.823-15.082a76.125,76.125,0,0,0,.393-15.8c-.217-4.116-.393-7.365.691-8.624a4.979,4.979,0,0,1,2.938-1.9h0c.311.068,2.41.718,3.425,1.029a14.325,14.325,0,0,0,3.7.88c11.115.569,18.345-4.1,21.4-13.715,2.166-6.823-1.137-14.364-5.388-18.805-4.305-4.508-11.264-6.552-21.364-6.16-6.052.217-18.643,3.222-27.416,13.16-2.491,2.816-8.272,10.438-8.164,20.416a22.049,22.049,0,0,0,.65,5.036c.122.528.257,1.11.393,1.868.027.176,2.586,15.759-5.835,22.271-4.211,3.276-9.734,3.128-11.9,2.938a18.839,18.839,0,0,1-8.137-2.789,5.656,5.656,0,1,0-5.984,9.6,30.3,30.3,0,0,0,13.051,4.441c4.359.42,12.74.284,19.888-5.253,13.5-10.452,10.452-30.827,10.059-33.116-.176-1-.352-1.787-.515-2.5a10.142,10.142,0,0,1-.366-2.613c-.068-6.052,3.7-10.966,5.321-12.794,7.812-8.841,19.239-9.355,19.347-9.355,8.6-.3,11.684,1.544,12.767,2.681,2.153,2.261,3.4,5.646,2.789,7.555-1.246,3.94-3.155,6.133-9.64,5.862-.338-.095-.8-.244-1.313-.406-3.1-.961-5.1-1.544-6.769-1.544h-.014c-5.849,0-9.992,4.062-11.494,5.822-4.075,4.7-3.764,10.492-3.439,16.639a66.721,66.721,0,0,1-.284,13.593c-.447,3.073-2.423,6.241-5.185,10.628-3.7,5.889-9.572,8.435-12.4,9.653-17.316,7.46-39.8-5.388-42.308-6.891a5.655,5.655,0,1,0-5.781,9.721C101.715,617.072,117.23,625.656,134.072,625.656Z",
    transform: "translate(-95.205 -530.215)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(1375.274 288.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M304.9,678.641l.65-.041,133.938-15.556a12.877,12.877,0,0,0,12.483-12.862l.65-219.178a12.876,12.876,0,0,0-12.862-12.875l-193.2,18.548h-.041c-6.526,0-12.28,5.754-12.28,12.835l.19,1.462L292.05,666.619A12.9,12.9,0,0,0,304.9,678.641ZM440.3,429.435a1.707,1.707,0,0,1,1,1.571l-.65,219.178a1.557,1.557,0,0,1-1.543,1.57l-.65.041L304.682,667.323a1.537,1.537,0,0,1-1.34-1.53l-.19-1.462L245.626,449.066A1.549,1.549,0,0,1,247.1,448Z",
    transform: "translate(-234.24 -418.13)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(1435.955 343.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M323.027,574.924A58.027,58.027,0,1,0,265,516.9,58.1,58.1,0,0,0,323.027,574.924Zm0-104.735A46.708,46.708,0,1,1,276.318,516.9,46.758,46.758,0,0,1,323.027,470.189Z",
    transform: "translate(-265 -458.87)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(1701.42 361.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M161.654,492.559a5.664,5.664,0,0,0,2.6-10.7,85.973,85.973,0,0,0-9.653-4.251,88.248,88.248,0,0,0-30.1-5.4h-.041a5.659,5.659,0,0,0-.041,11.318,77.286,77.286,0,0,1,26.251,4.712,74.478,74.478,0,0,1,8.394,3.7A5.683,5.683,0,0,0,161.654,492.559Z",
    transform: "translate(-118.804 -472.21)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(1697.06 375.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M162.343,514.426a5.652,5.652,0,0,0,4.1-9.545,102.091,102.091,0,0,0-29.067-21.418,5.664,5.664,0,0,0-5,10.168,90.822,90.822,0,0,1,25.845,19.035A5.681,5.681,0,0,0,162.343,514.426Z",
    transform: "translate(-129.212 -482.879)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(1629.906 332.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M198.565,472.291c.257,0,.514,0,.772-.014,11.237-.433,17.018-9.653,17.654-10.709a5.655,5.655,0,1,0-9.721-5.781c-.135.23-3.073,4.982-8.353,5.185a10.511,10.511,0,0,1-9.788-6.4,5.661,5.661,0,1,0-10.344,4.6A21.938,21.938,0,0,0,198.565,472.291Z",
    transform: "translate(-178.294 -451.207)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M268.947,546.658c16.774-1.489,18.467-1.069,19.861,0,5.646,4.319,8.353,21.053-.366,27.091-14.933,10.344-40.426,7.2-91.3-9.883-1.76-.6-5.05-4.847-7.663-8.9a15.856,15.856,0,0,1,.366-16.977c3.682-5.321,9.924-6.363,10.831-6.5,9.68-1.462,12.821,6.851,29.257,12.645a65.294,65.294,0,0,0,21.675,3.967C255.693,548.133,256.9,547.727,268.947,546.658Z",
    transform: "translate(1363.304 -89.927)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(1693.488 329.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M156.5,471.512a5.664,5.664,0,0,0,5.578-4.793l1.774-11.494a5.658,5.658,0,1,0-11.183-1.733L150.9,464.986a5.661,5.661,0,0,0,4.725,6.458A6.57,6.57,0,0,0,156.5,471.512Z",
    transform: "translate(-150.831 -448.703)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(1595.685 321.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M228.742,465.582a5.664,5.664,0,0,0,5.578-4.793l1.774-11.494a5.658,5.658,0,1,0-11.183-1.733l-1.774,11.494a5.661,5.661,0,0,0,4.725,6.458A4.835,4.835,0,0,0,228.742,465.582Z",
    transform: "translate(-223.071 -442.773)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(1463.336 363.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(15.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M309.3,544.2a7.311,7.311,0,0,0,1.489-.149c7.568-1.692,12.713-6.621,14.486-13.891,4.6-18.832-.718-35.376-15.813-49.132a20.607,20.607,0,0,0-14.08-5.429,24.046,24.046,0,0,0-7.04,1.083l-2.031.623,1.151,1.787c.433.677.839,1.354,1.246,2.031a34.233,34.233,0,0,0,2.992,4.414c6.688,7.92,8.57,16.747,5.74,27.009a47.956,47.956,0,0,0-1.868,11.792c-.108,6.62,2.938,12.794,9.071,18.386A7.425,7.425,0,0,0,309.3,544.2Z",
    transform: "translate(-282.308 -473.095)",
    fill: "#b77866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M287.532,477.786a61.412,61.412,0,0,0,4.129,6.282c7.243,8.583,8.936,18.034,6.065,28.472a46.782,46.782,0,0,0-1.814,11.4c-.108,6.851,3.412,12.483,8.543,17.167a6.269,6.269,0,0,0,4.7.961c7.243-1.625,11.711-6.323,13.268-12.713,4.481-18.386-.866-34.375-15.339-47.575C301.68,476.838,294.464,475.647,287.532,477.786Z",
    transform: "translate(-281.033 -472.682)",
    fill: "#b77866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M289.53,474.982a26.962,26.962,0,0,1,7.92-1.232,23.226,23.226,0,0,1,15.921,6.16c15.786,14.405,21.351,31.694,16.544,51.433-2.017,8.231-7.853,13.823-16.45,15.732a9.571,9.571,0,0,1-2.125.217,9.876,9.876,0,0,1-6.526-2.193c-6.674-6.079-9.992-12.862-9.87-20.173a49.157,49.157,0,0,1,1.949-12.361c2.613-9.477.894-17.614-5.253-24.9a36.228,36.228,0,0,1-3.331-4.9c-.365-.6-.717-1.191-1.11-1.787l-2.857-4.4Zm8.245,6.932c.176.23.352.447.528.663,7.852,9.3,10.168,20.078,6.864,32.06a41.635,41.635,0,0,0-1.665,10.438c-.081,5.023,2.274,9.653,6.959,13.959a2.807,2.807,0,0,0,.961.135h.081c5.415-1.219,8.814-4.468,10.086-9.667,4.089-16.734-.677-31.437-14.134-43.716A14.759,14.759,0,0,0,297.775,481.914Z",
    transform: "translate(-284.345 -473.75)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 2.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M328.749,543.931a27.392,27.392,0,0,0,7.2-.975l2.491-.677-1.719-1.936a29.212,29.212,0,0,1-2.694-3.561,28.721,28.721,0,0,0-1.706-2.369c-5.212-6.3-6.038-11.968-2.843-19.591,6.323-15.028-.894-26.874-8.786-36.473-.961-1.164-2.992-1.3-3.818-1.3a6.18,6.18,0,0,0-2.586.487c-7.067,3.3-11.332,9.3-12.7,17.817-2.153,13.39-2.735,30.408,12.063,43.324A23.176,23.176,0,0,0,328.749,543.931Z",
    transform: "translate(-297.765 -474.6)",
    fill: "#b77866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M336.059,540.993c-2.315-2.6-2.924-4.143-4.441-5.971-5.713-6.9-6.485-13.146-3.087-21.242,5.646-13.444-.027-24.464-8.543-34.835-.636-.772-3.3-.934-4.481-.379-7.3,3.412-10.682,9.613-11.806,16.612-2.586,16.057-1.327,30.624,11.535,41.848C319.921,541.142,327.787,543.24,336.059,540.993Z",
    transform: "translate(-298.292 -474.179)",
    fill: "#b77866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M298.225,495.629c1.5-9.355,6.268-15.962,14.134-19.645a9.212,9.212,0,0,1,3.832-.745c2.572,0,4.725.826,5.9,2.274,7.839,9.545,15.975,22.6,9.139,38.843-2.884,6.891-2.22,11.548,2.478,17.208a29.945,29.945,0,0,1,1.882,2.6,26.67,26.67,0,0,0,2.464,3.249l4.278,4.806-6.363,1.733a30.216,30.216,0,0,1-8,1.07,25.523,25.523,0,0,1-16.883-5.93C295.4,527.4,295.964,509.615,298.225,495.629Zm18.643,39.479a16.863,16.863,0,0,0,10.344,3.75c-.068-.095-.135-.176-.2-.257-6.566-7.92-7.7-15.719-3.7-25.263,5.05-12.009-.758-21.892-7.284-30-5.158,2.464-8.313,7.013-9.355,13.539C303.762,514.895,306.809,526.335,316.868,535.108Z",
    transform: "translate(-297.04 -475.24)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(1541.704 436.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M255.9,586.719a129.466,129.466,0,0,0,44.637-8.3,5.658,5.658,0,1,0-3.886-10.628c-21.811,7.988-43.093,9.694-63.252,5.091-22.934-5.239-37.434-13.5-38.775-22.082-.487-3.087.311-8.637,3.547-10.777,3.209-2.112,8.3-.406,8.516-.325,2.139.745,4.265,2.627,5.822,4.008.718.636,1.34,1.191,1.868,1.584,7.771,5.917,13.43,6.9,27.132,9.315,20.917,3.669,43.459,1.286,55.035-.46a5.655,5.655,0,1,0-1.692-11.183c-8.773,1.327-31.328,4.048-51.379.5-13.471-2.369-16.856-3.073-22.231-7.175-.338-.257-.745-.623-1.2-1.029-2.139-1.9-5.348-4.766-9.639-6.255-2.478-.853-11.129-3.263-18.453,1.6-7.419,4.9-9.6,14.825-8.489,21.959,2.748,17.6,27.308,26.78,47.426,31.369A113.014,113.014,0,0,0,255.9,586.719Z",
    transform: "translate(-183.186 -527.65)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M146.971,605.707a10.549,10.549,0,0,0-2.031-6.512,5.526,5.526,0,0,1,3.006.866c30.652,20.741,70.063,20.538,93.715-.5,13.16-11.7,21.675-32.154,21.7-52.123a69.379,69.379,0,0,0-2.288-17.736,5.66,5.66,0,0,1,10.953-2.856,80.8,80.8,0,0,1,2.654,20.606c-.027,23.043-10.032,46.817-25.493,60.572-14.026,12.469-32.669,18.724-52.219,18.724a99.07,99.07,0,0,1-51.65-14.987A11.257,11.257,0,0,0,146.971,605.707Z",
    transform: "translate(1439.872 -93.008)",
    fill: "#231f20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(369.009 523.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 255.399,
    height: 41.889,
    transform: "matrix(-0.995, 0.095, -0.095, -0.995, 1610.769, 289.462)",
    fill: "#a56a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M241.93,417.451l207.128-19.766-14.08-32.845L248.916,384.4Z",
    transform: "translate(1134.184 -148.841)",
    fill: "#b77866"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(1344 241.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M230.937,463.258a11.384,11.384,0,0,0,1.178-.054l247.473-23.936a11.935,11.935,0,0,0,10.723-13.024l-3.1-32.087A11.975,11.975,0,0,0,474.2,383.434l-247.473,23.95A11.933,11.933,0,0,0,216,420.394l3.1,32.087a11.934,11.934,0,0,0,11.833,10.777ZM475.324,394.7a.591.591,0,0,1,.6.541l3.114,32.1a.681.681,0,0,1-.542.663L231.018,451.939a.636.636,0,0,1-.663-.541l-3.1-32.087a.655.655,0,0,1,.542-.65L475.269,394.7Z",
    transform: "translate(-215.95 -383.381)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(1369.053 211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M247.095,424.2a11.334,11.334,0,0,0,1.164-.054l200.413-19.387a9.678,9.678,0,0,0,7.934-14.54l-10.723-20.877a15.9,15.9,0,0,0-14.892-8.137L255.353,378.2a15.188,15.188,0,0,0-12.821,11.2l-5.239,22.19a10.237,10.237,0,0,0,2.085,9.247A10.034,10.034,0,0,0,247.095,424.2Zm1.191-10.019v.095l-5.483-1.394Zm197.38-20.511L248.652,412.734l4.9-20.755a4.106,4.106,0,0,1,2.9-2.532l175.637-16.991a4.728,4.728,0,0,1,3.75,2.044Z",
    transform: "translate(-236.974 -361.147)",
    fill: "#231f20"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(369.009 523.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(35 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(444 698)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(206 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(225 535)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(51 174)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(259 754)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 18,
    y2: 20,
    transform: "translate(115.5 520.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 17,
    y2: 15,
    transform: "translate(107.5 48.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M0,0-11.356,27.29",
    transform: "translate(76.5 716.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0,5.307,24.232",
    transform: "translate(587.837 790.558)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 22,
    y2: 6,
    transform: "translate(54.5 292.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 16,
    y2: 19.5,
    transform: "translate(376.5 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.26fadd97e89a2995a7dbd581d0382c1c.svg";
export { ForwardRef as ReactComponent };